import ViewIndicativeOfferModal from '../../../shared_components/ViewIndicativeOfferModal/ViewIndicativeOfferModal';
import ViewRoadAssistanceModal from '../../../shared_components/ViewRoadAssistanceModal/ViewRoadAssistanceModal';

const ViewInfoModal = ({
    showInfoModal,
    closeModal,
    goNext
}: {
    showInfoModal: string;
    closeModal: () => void;
    goNext: () => void;
}): React.JSX.Element => {
    return (
        <>
            {showInfoModal === 'IndicativeOffer' && (
                <ViewIndicativeOfferModal
                    closeModal={closeModal}
                    showModal={true}
                    goNext={goNext}
                />
            )}
            {showInfoModal === 'RoadAssistance' && (
                <ViewRoadAssistanceModal closeModal={closeModal} showModal={true} goNext={goNext} />
            )}
        </>
    );
};

export default ViewInfoModal;
